import React from 'react';
import { TextField, Button, Typography, Container, Box, Avatar, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
import MailIcon from '@mui/icons-material/Mail';
import InputAdornment from '@mui/material/InputAdornment';

const ForgotPassword = ({ switchToPasswordConfirm, setEmail }) => {

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

      <Avatar 
        alt="Logo" 
        src="logo.png" 
        variant="rounded" 
        sx={{
            height: 134,
            width: 134,
            maxHeight: { xs: 233, md: 167 },
            maxWidth: { xs: 350, md: 250 },
          }} />

        <Typography component="h1" variant="h5" sx={{ mt: 2 }}>
          Password Reset
        </Typography>

        <Typography component="p" sx={{ mt: 2 }}>
          to access your InspectReply AI account
        </Typography>

        <Box component="form" sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            autoFocus
            onChange={(e) => setEmail(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <MailIcon />
                </InputAdornment>
              ),
            }}
          />

            <Stack direction="row" justifyContent="space-between" spacing={2}>
              <Button 
                  component={Link} 
                  to="/sign-in" 
                  variant="text"
              >
                  Back
              </Button>
              <Button
                component="label"
                variant="contained"
                onClick={switchToPasswordConfirm}
                sx={{ mt: 3, mb: 2, borderRadius: 28, ml: "auto" }}
              >
                Continue
              </Button>
            </Stack>
        </Box>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
